import { Modal } from 'antd'
import deleteEmail from '../Services/delete'

export default () => (dispatch) => {

  Modal.confirm({
    title: `Are you sure to delete this email?`,
    content: 'This action cannot be undone',
    okText: 'Yes',
    width: 400,
    onOk: () => dispatch(deleteEmail()),
  })

}
